<script>
import Main from './main.vue';

export default Main.extend({
  methods: {
    getData() {
      return new Promise((res) => {
        // Seed data
        const output = [
          {
            name: 'Industry sector(s)',
            data: [{
              x: 0,
              y: 1,
              data: 5,
            }],
          },
        ];
        res(output);
      });
    },
  },
});
</script>
